module.exports = __webpack_public_path__ + "img/icon0.adf26d27.svg";